webpackJsonp([76],{

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1276);


/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _es = __webpack_require__(789);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('es', _es2.default);

/***/ })

},[1275]);


// WEBPACK FOOTER //
// app/datetime.es-c797e26733562d73c800.js